import { CopyOutlined, LinkOutlined } from '@ant-design/icons';
import { App, Tooltip } from 'antd';
import { shortId } from './ids';

/** Copies text, also where the clipboard API isn't allowed (plain http). */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.append(area);
    area.select();
    const ok = document.execCommand('copy');
    area.remove();
    return ok;
  }
}

/**
 * A record's id, to send to whoever helps (doc 56): «#3f2a1b9c», and a click
 * copies the full id, which every search box accepts. `link` also copies the
 * page's address.
 */
export function IdTag({
  id,
  label = 'المعرّف',
  link = false,
}: {
  id: string;
  label?: string;
  link?: boolean;
}) {
  const { message } = App.useApp();
  const copy = async (text: string, done: string) => {
    if (await copyText(text)) message.success(done);
    else message.error('تعذّر النسخ.');
  };
  return (
    <span className="id-tag">
      {label && <span className="id-tag-label">{label}</span>}
      <Tooltip title={`${id} · انقر للنسخ`}>
        <button
          type="button"
          className="id-tag-copy"
          aria-label={`نسخ ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            copy(id, 'نُسخ المعرّف');
          }}
        >
          <span className="ltr-num">#{shortId(id)}</span>
          <CopyOutlined />
        </button>
      </Tooltip>
      {link && (
        <button
          type="button"
          className="id-tag-copy"
          onClick={(e) => {
            e.stopPropagation();
            copy(window.location.href, 'نُسخ الرابط');
          }}
        >
          <LinkOutlined /> نسخ الرابط
        </button>
      )}
    </span>
  );
}
